// Written in this round about way for babel-transform-imports
import Redirect from "react-router/es/Redirect";

export default Redirect;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-router-dom/es/Redirect.js
// module id = 434
// module chunks = 4 5 6 7